<div class="timed-selection">
    <div class="question question-{{id}} {{class}}">
        <div class="question-text"><div class="text">{{{t text}}}</div></div>
        {{#if blocks}}<div data-region="question-blocks" class="question-blocks"></div>{{/if}}
        <div class="answers-container" data-answer-count="{{answers.length}}">
            {{#each answers}}
                <div class="question-answer"><div class="text">{{{t text}}}</div></div>
            {{/each}}
        </div>
        <div id="timed-selection-submit-button" class="timed-selection-submit-button">{{{t button_text}}}</div>
    </div>
</div>